import React, { useEffect } from "react";
import { PromoBar } from "./components/PromoBar";
import { Hero } from "./components/Hero";
import { HowToUse } from "./components/HowToUse";
import { LessonExample } from "./components/LessonExample";
import { PainSection } from "./components/PainSection";
import { WhatYouGet } from "./components/WhatYouGet";
import { Pricing } from "./components/Pricing";
import { Guarantee } from "./components/Guarantee";
import { Testimonials } from "./components/Testimonials";
import { Faq } from "./components/Faq";
import { BeforeAfter } from "./components/BeforeAfter";
import { FinalCta } from "./components/FinalCta";
import { Footer } from "./components/Footer";
import { MobileCtaBar } from "./components/MobileCtaBar";
import { initPixel } from "./utils/pixel";
import { pageTitle } from "./data/content";
type AppProps = {
  showTestimonials?: boolean;
};
export function App({
  showTestimonials = false
}: AppProps) {
  useEffect(() => {
    document.title = pageTitle;
    initPixel();
  }, []);
  return <div lang="fr" className="min-h-screen w-full overflow-x-hidden bg-ink pb-20 font-sans text-cream antialiased md:pb-0" data-id="element-0" data-mp="3ij61k21ff746">
      <PromoBar data-id="element-1" data-mp="3mjg7xft4rzjk" />
      <main data-id="element-2" data-mp="3rc9d24sih9w6">
        <Hero data-id="element-3" data-mp="3rcj2nr9n9f1c" />
        <HowToUse data-id="element-4" data-mp="3rbznujfaj6rj" />
        <LessonExample data-id="element-5" data-mp="3rdkgu4lyihna" />
        <PainSection data-id="element-6" data-mp="3recedkz46pg7" />
        <WhatYouGet data-id="element-7" data-mp="5yhgo69t1c8" />
        <Pricing data-id="element-8" data-mp="67z9oh5w26u" />
        <Guarantee data-id="element-9" data-mp="4n4bxqxqh8g" />
        {showTestimonials && <Testimonials data-id="element-10" data-mp="7svdij4jt6t" />}
        <Faq data-id="element-11" data-mp="2zld43f9knpe6" />
        <BeforeAfter data-id="element-12" data-mp="2zlv7qwykd5w4" />
        <FinalCta data-id="element-13" data-mp="2zmem63p09c5e" />
      </main>
      <Footer data-id="element-14" data-mp="2zng0qi58cgrv" />
      <MobileCtaBar data-id="element-15" data-mp="33moqzd129wio" />
    </div>;
}